<app-comision-home *ngIf="commisionRol" [userData]="userData" ></app-comision-home>
<app-simple-rol-home *ngIf="!commisionRol && !SuperAdminRol" [userData]="userData"></app-simple-rol-home>
<app-SuperAdmin-home *ngIf="SuperAdminRol" [userData]="userData"></app-SuperAdmin-home>
